import { render, staticRenderFns } from "./KnowledgeBaseFiles.vue?vue&type=template&id=7186951d&scoped=true&"
import script from "./KnowledgeBaseFiles.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeBaseFiles.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBaseFiles.vue?vue&type=style&index=0&id=7186951d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7186951d",
  null
  
)

export default component.exports